<div class="card-group">
  @for (imgUrl of imgUrls; track $index; let i = $index) {
    <div class="thumbnail-card card">
      <img (click)="onClick(i, imgUrl)" [src]="imgUrl.w150" class="widget-thumbnail hover-pointer" />
    </div>
  }
</div>
